import React from "react";

import { faFile } from "@fortawesome/pro-light-svg-icons/faFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Popover from "antd/es/popover";
import { useIntl } from "react-intl";

import { Activity } from "@mapmycustomers/shared/types/entity";

import styles from "./NoteCellRenderer.module.scss";

interface Props {
  activity?: Activity;
}

const NoteCellRenderer: React.FC<Props> = ({ activity }) => {
  const intl = useIntl();
  if (!activity?.note) {
    return (
      <div className={styles.noNote}>
        {intl.formatMessage({
          id: "activityListModal.column.note",
          defaultMessage: "No note",
          description: "No note label on note cell in activity list modal",
        })}
      </div>
    );
  }
  return (
    <div>
      <Popover content={<div>{activity?.note}</div>}>
        <div className={styles.note}>
          {intl.formatMessage(
            {
              id: "activityListModal.note",
              defaultMessage: "{icon} Note",
              description: "Description text in the notes cell",
            },
            {
              icon: <FontAwesomeIcon icon={faFile} />,
            }
          )}
        </div>
      </Popover>
    </div>
  );
};

export default NoteCellRenderer;
